@if (form) {
  <form (ngSubmit)="onSubmit()" [formGroup]="form" class="grid grid-cols-12" novalidate>
    <app-form-time-period
      [form]="form"
      [maxFractionDigits]="1"
      [minFractionDigits]="1"
      id="entries"
      inputType="number"
      label="GLOBAL.VALUE"></app-form-time-period>
    <app-form-button-bar (onCancel)="cancel()" [form]="form" [saveDisabled]="submitting"></app-form-button-bar>
  </form>
}
